<div class="categories" [sortablejs]="categories" [sortablejsOptions]="options">
  <registry-category [id]="category.id" [registry]="registry" [category]="category" [parent]="parent" [editMode]="editMode" *ngFor="let category of categories"></registry-category>
</div>
